import FormAutoComplete from "@/pages/search-advance/FormAutoComplete.vue";

//Esta com window, pois outra página pode querer aceder a este elemento
window.searchAdvanced = new Vue({
    el: '#advancedSearchForm',
    name: 'AdvancedSearch',
    components: {
        'FormAutocomplete': FormAutoComplete,
    },
    data() {
        return {
            countryA: { Label: null, Name: null, api_id: null },
            priceRentOptions: [
                '0',
                '50',
                '100',
                '150',
                '200',
                '250',
                '300',
                '350',
                '400',
                '450',
                '500',
                '550',
                '600',
                '650',
                '700',
                '750',
                '850',
                '900',
                '1.000',
                '1.100',
                '1.200',
                '1.300',
                '1.400',
                '1.500',
                '1.600',
                '1.700',
                '1.800',
                '1.900',
                '2.000',
                '2.100',
                '2.400',
                '2.700',
                '3.000'
            ],
            priceSellOptions: [
                '0',
                '60.000',
                '80.000',
                '100.000',
                '120.000',
                '140.000',
                '160.000',
                '180.000',
                '200.000',
                '220.000',
                '240.000',
                '260.000',
                '280.000',
                '300.000',
                '320.000',
                '340.000',
                '360.000',
                '380.000',
                '400.000',
                '450.000',
                '500.000',
                '550.000',
                '600.000',
                '650.000',
                '700.000',
                '750.000',
                '800.000',
                '850.000',
                '900.000',
                '950.000',
                '1.000.000',
                '1.100.000',
                '1.200.000',
                '1.300.000',
                '1.400.000',
                '1.500.000',
                '1.600.000',
                '1.700.000',
                '1.800.000',
                '1.900.000',
                '2.000.000',
                '2.100.000',
                '2.200.000',
                '2.300.000',
                '2.400.000',
                '2.500.000',
                '2.600.000',
                '2.700.000',
                '2.800.000',
                '2.900.000',
                '3.000.000'
            ],
            options: {
                height: 10,
                dotSize: 25,
            },
            rooms: {
                min: null,
                max: null,
            },
            input: 0,
            neg: 0,
            ref: 0,
            refValue: null,
            areas: 0,
            minArea: '',
            maxArea: '',
            minRoom: 0,
            maxRoom: 6,
            showAreas: false,
            // showQuartos: 1,
            minPriceRentText: '',
            maxPriceRentText: '',
            minPriceSellText: '',
            maxPriceSellText: '',
            enableCross: false,
            aPropType: null,
            PropTypeId: null,
            PropTypeGroup: null,
            PropTypeName: null,
            // showAreas: null,
            negLabel: 'Comprar',
            showQuartos: true,
            requestFinalidade: null,
            requestPropType: null,
            requestMaxprice: null,
            requestMinprice: null,
            requestMinQuartos: null,
            requestMaxQuartos: null,
            requestMinArea: null,
            requestAmi: null,
            requestRef: null,
            prop_storage_room: null,
            prop_garage_car_spots: null,
            prop_terraces: null,
            prop_balconies: null,
            propertyTypes: null,
            withoutExclued: false,
            useRef: true,
        }
    },

    watch: {
        // whenever question changes, this function will run
        priceRent: function (newQuestion, oldQuestion) {
            this.minPriceRentText = newQuestion[0].replace('.', '');

            this.maxPriceRentText = newQuestion[1].replace('.', '');
        },
        priceSell: function (newQuestion, oldQuestion) {
            this.minPriceSellText = newQuestion[0].replace('.', '');
            this.maxPriceSellText = newQuestion[1].replace('.', '');
        },
        rooms: function (newQuestion, oldQuestion) {
            this.minRoom = newQuestion[0];
            this.maxRoom = newQuestion[1];
        }
    },
    mounted() {

        console.log('requestFinalidade', this.requestFinalidade)
        if (this.requestFinalidade && this.requestFinalidade.hasOwnProperty('Label') && this.requestFinalidade.Label) {
            console.log(this.requestFinalidade.Label, 'mounted')

            if (this.requestFinalidade.Label === 'Venda') {
                document.getElementById('Venda')?.classList.add('filter-active');
                this.negClick('Comprar', 1, 'mounted');
            } else if (this.requestFinalidade.Label === 'Arrendamento') {
                document.getElementById('Arrendamento')?.classList.add('filter-active');
                this.negClick('Arrendar', 0, 'mounted');
            } else if (this.requestFinalidade.Label === 'Comprar') {
                document.getElementById('Venda')?.classList.add('filter-active');
                this.negClick('Comprar', 1, 'mounted');
            } else if (this.requestFinalidade.Label === 'Arrendar') {
                document.getElementById('Arrendamento')?.classList.add('filter-active');
                this.negClick('Arrendar', 0, 'mounted');
            } else if (this.requestFinalidade.Label === 'Para Férias') {
                this.negClick('Para Férias', 0, 'mounted');
            } else if (this.requestFinalidade.Label === 'Cedência de Quotas') {
                this.negClick('Cedência de Quotas', 1, 'mounted');
            } else if (this.requestFinalidade.Label === 'Trespasse/Quotas') {
                this.negClick('Trespasse/Quotas', 1, 'mounted');
            }
        }

        if (this.refValue) {
            const filterRef = document.getElementById("filterRef");
            const filterBasic = document.getElementById("filterBasic");
            if (filterRef && filterBasic) {
                filterRef.classList.remove("border-bottom");
                filterRef.classList.remove("not-selected");
                filterBasic.classList.add("border-bottom");
                filterBasic.classList.add("not-selected");
                filterBasic.classList.remove("border-top-right-radius");
            }
        }

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('useRef')) {
            this.ref = 1;
            this.changeFilter(1);
        }

        const refInput = document.getElementById('_ref');
        if (refInput) {
            refInput.addEventListener('focus', () => {
                if (window.innerWidth <= 768) {
                    document.body.classList.add('search-focused-mobile');
                    setTimeout(() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        const formElement = document.getElementById('advancedSearchForm');
                        if (formElement) {
                            formElement.scrollIntoView({ behavior: "smooth", block: "start" });
                        }
                    }, 300);
                }
            });

            refInput.addEventListener('blur', () => {
                if (window.innerWidth <= 768) {
                    document.body.classList.remove('search-focused-mobile');
                }
            });
        }
    },
    beforeMount: function () {
        this.initializeVars();
    },
    methods: {
        initializeVars() {
            const el = document.querySelector('[name="props-js"]')

            if (el) {
                Object.assign(this.$data, JSON.parse(el.value))
            }

            // `this` points to the view model instance
            if (this.requestPropType) {
                /* console.log('requestPropType', this.requestPropType);*/
                this.PropTypeGroup = this.requestPropType.prop_type_group;
                this.PropTypeName = this.requestPropType.prop_type_name;
                this.PropTypeId = this.requestPropType.id;

                if (this.PropTypeName === "Quarto") {
                    this.showAreas = true;

                    this.$nextTick(() => this.showQuartos = false);

                } else if (this.PropTypeGroup === "1") {

                    this.showQuartos = true;
                    this.$nextTick(() => this.showAreas = false);
                } else {
                    this.showAreas = true;
                    this.$nextTick(() => this.showQuartos = false);


                }
            }
            if (this.requestMaxprice || this.requestMinprice) {

                if (this.requestMaxprice && !this.requestMinprice) {
                    this.priceRent = [0, this.requestMaxprice];
                    this.priceSell = [0, this.requestMaxprice];

                    this.maxPriceRentText = this.requestMaxprice;
                    this.maxPriceSellText = this.requestMaxprice;
                } else if (!this.requestMaxprice && this.requestMinprice) {
                    this.minPriceRentText = this.requestMinprice;
                    this.minPriceSellText = this.requestMinprice;

                } else {
                    this.priceRent = [this.requestMinprice, this.requestMaxprice];
                    this.priceSell = [this.requestMinprice, this.requestMaxprice];

                    this.maxPriceRentText = this.requestMaxprice;
                    this.maxPriceSellText = this.requestMaxprice;
                    this.minPriceRentText = this.requestMinprice;
                    this.minPriceSellText = this.requestMinprice;

                }
            }
            // if(this.requestFinalidade){
            //     console.log('before mount',this.requestFinalidade);
            //     this.negLabel=this.requestFinalidade.Label;
            //     if(this.requestFinalidade.Price === 0){
            //         this.neg=1;
            //     }else{
            //         this.neg=0;
            //     }
            // }

            if (this.requestMinQuartos || this.requestMaxQuartos) {
                console.log('minQuartos', this.requestMinQuartos)
                console.log('maxQuartos', this.requestMaxQuartos)
                if (this.requestMinQuartos && !this.requestMaxQuartos) {
                    this.minRoom = this.requestMinQuartos;
                    this.rooms.min = this.requestMinQuartos;
                    this.rooms.max = 6;

                } else if (!this.requestMinQuartos && this.requestMaxQuartos) {
                    this.maxRoom = this.requestMaxQuartos;
                    this.rooms.min = 0;
                    this.rooms.max = this.requestMaxQuartos;

                } else {
                    this.minRoom = this.requestMinQuartos;
                    this.maxRoom = this.requestMaxQuartos;
                    this.rooms.min = this.requestMinQuartos;
                    this.rooms.max = this.requestMaxQuartos;
                }
            }

            if (this.requestMinArea) {
                this.showAreas = true;
                this.areas = this.requestMinArea;
                // this.$nextTick(() => this.showQuartos = false);
            }

            if (!this.prop_balconies
                || this.prop_balconies === undefined
                || this.prop_balconies === null
                || this.prop_balconies === 'null'
                || this.prop_balconies === 'undefined'
            ) {
                this.prop_balconies = null;
            }

            if (!this.prop_terraces
                || this.prop_terraces === undefined
                || this.prop_terraces === null
                || this.prop_terraces === 'null'
                || this.prop_terraces === 'undefined'
            ) {
                this.prop_terraces = null;
            }

            if (!this.prop_garage_car_spots
                || this.prop_garage_car_spots === undefined
                || this.prop_garage_car_spots === null
                || this.prop_garage_car_spots === 'null'
                || this.prop_garage_car_spots === 'undefined'
            ) {
                this.prop_garage_car_spots = null;
            }

            if (!this.prop_storage_room
                || this.prop_storage_room === undefined
                || this.prop_storage_room === null
                || this.prop_storage_room === 'null'
                || this.prop_storage_room === 'undefined'
            ) {
                this.prop_storage_room = null;
            }

            if (this.requestRef) {
                this.ref = 1;
                this.refValue = this.requestRef;
            }
        },
        funcMinPriceRentText: function (value) {
            this.minPriceRentText = value.replace('.', '').replace('.', '');
            if (this.maxPriceRentText === '') {
                this.maxPriceRentText = '3000';
            }

            this.refreshPage();
        },
        funcMaxPriceRentText: function (value) {
            this.maxPriceRentText = value.replace('.', '').replace('.', '');

            if (this.minPriceRentText === '') {
                this.minPriceRentText = '0';
            }

            this.refreshPage();
        },
        funcMinPriceSellText: function (value) {
            this.minPriceSellText = value.replace('.', '').replace('.', '');

            if (this.maxPriceSellText === '') {
                this.maxPriceSellText = '3000000';
            }

            this.refreshPage();
        },
        funcMaxPriceSellText: function (value) {
            this.maxPriceSellText = value.replace('.', '').replace('.', '');

            if (this.minPriceSellText === '') {
                this.minPriceSellText = '0';
            }

            this.refreshPage();
        },
        setArea: function (label, value) {
            if (label === 'Max') {
                this.maxArea = value
            }
            if (label === 'Min') {
                this.minArea = value
            }

            this.refreshPage();
        },
        changeFilter: function (value) {
            this.ref = value;
            const filterRef = document.getElementById("filterRef");
            const filterBasic = document.getElementById("filterBasic");
            if (!filterRef || !filterBasic) return;

            if (value === 1) {
                //filterBasic.classList.remove("box-search-filter");

                filterRef.classList.remove("border-bottom");
                filterRef.classList.remove("not-selected");
                filterBasic.classList.add("border-bottom");
                filterBasic.classList.add("not-selected");
                filterBasic.classList.add("border-top-left-radius");

                //filterRef.classList.add("box-search-ref");
            } else {
                // filterBasic.classList.add("border-top-right-radius");

                filterBasic.classList.remove("border-bottom");
                filterBasic.classList.remove("not-selected");
                filterRef.classList.add("border-bottom");
                filterRef.classList.add("not-selected");
                filterRef.classList.add("border-top-right-radius");

                //filterBasic.classList.add("box-search-filter");
            }
        },
        negClick: function (label, type, mounted = null) {
            this.negLabel = label;
            /* console.log('Finalidade', this.negLabel) */
            if (type === 0) {
                this.neg = 1;
            } else {
                this.neg = 0;
            }
            // console.log(this.neg)
            this.requestFinalidade = null;
            const filterActive = document.querySelector('.filter-active')
            if (filterActive) {
                filterActive.classList.remove('filter-active')
            }
            if (label == 'Comprar') {
                const labelDiv = document.getElementById('Venda')
                // console.log(labelDiv)
                if (labelDiv) {
                    labelDiv.classList.add('filter-active')
                }
            } else if (label == 'Arrendar') {
                const labelDiv = document.getElementById('Arrendamento')
                // console.log(labelDiv)
                if (labelDiv) {
                    labelDiv.classList.add('filter-active')
                }
            }

            if (mounted === null) {
                this.refreshPage();
            }
        },
        setPropType: function (group, name, id) {
            this.PropTypeGroup = group;
            this.PropTypeName = name;
            this.PropTypeId = id;

            if (this.PropTypeName === "Quarto") {
                this.showAreas = true;
                this.$nextTick(() => this.showQuartos = false);

            } else if (this.PropTypeGroup === "1") {

                this.showQuartos = true;
                this.$nextTick(() => this.showAreas = false);
            } else {
                this.showAreas = true;
                this.$nextTick(() => this.showQuartos = false);
            }

            this.refreshPage();
        },

        changeNumOfRoomsMin(Nrooms) {
            this.rooms.min = Nrooms;

            this.refreshPage();
        },

        changeNumOfRoomsMax(Nrooms) {
            this.rooms.max = Nrooms;

            this.refreshPage();
        },
        changeRef(advref) {
            /*console.log(this.refValue)*/
            /*    this.refValue = advref;*/

            this.refreshPage();
        },
        changeFeatures(value) {
            console.log(value);
            this.refreshPage();
        },

        number_format: function (number, decimals, dec_point, thousands_point) {

            if (number == null || !isFinite(number)) {
                throw new TypeError("number is not valid");
            }

            if (!decimals) {
                var len = number.toString().split('.').length;
                decimals = len > 1 ? len : 0;
            }

            if (!dec_point) {
                dec_point = '.';
            }

            if (!thousands_point) {
                thousands_point = ',';
            }

            number = parseFloat(number).toFixed(decimals);

            number = number.replace(".", dec_point);

            var splitNum = number.split(dec_point);
            splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
            number = splitNum.join(dec_point);

            return number;
        },

        refreshPage() {
            setTimeout(function () {
                // document.getElementById('advancedSearchForm').submit();
                //Codigo de cima só submetia o form normalmente sem passar pela funçao de validação mencionada no onsubmit na tag form
                //com o codigo debaixo mesmo no auto submit do form no preenchimento dos selects o codigo nao passa por cima da validação

                // CUIDADO!!! AO MEXER AQUI EXISTE OUTRO TRIGGER AO FORMULARIO SÓ PARA O SELECTOR DA LOCALIZAÇÃO

                // Marcar como autosubmit para manter o formulário aberto em mobile
                var form = document.getElementById('advancedSearchForm');
                form.setAttribute('data-autosubmit', 'true');
                form.dispatchEvent(new CustomEvent('submit', { cancelable: true }));
            }, 5);
        }
    }
})

// on scroll add class to a class a div.stycky-search.stycky-wrapper-search

window.addEventListener('scroll', function () {
    let header = document.querySelector('.only-show-mobile #open-search');
    let header2 = document.querySelector('.new-search-clip');
    let headersearch = document.querySelector('.stycky-search.stycky-wrapper-search #normalSearchWrapper');
    let headermap = document.querySelector('.map-target-for-fixed');
    let headersavesearch = document.querySelector('.mobile-sticky-bottom');
    let defaultScrollPositionOne = 300;
    let defaultScrollPositionTwo = 350;

    //check if the search is open
    // find the name="filter-mobile" and check if it has the value 'open'

    /* let searchOpen = document.querySelector('[name="filter-mobile"]').value;
     console.log(window.scrollY);
     if(searchOpen === 'open'){
         defaultScrollPositionOne = 1200;
         defaultScrollPositionTwo = 1250;
     }
 */
    /*console.log(header2);*/

    //stage 1
    let windowPosition = window.scrollY > defaultScrollPositionOne;
    if (header) {
        header.classList.toggle('scrolling-active', windowPosition);
    }
    if (header2) {
        header2.classList.toggle('scrolling-active', windowPosition);
    }
    /* header.classList.toggle('scrolling-active', windowPosition);*/
    /*header2.classList.toggle('scrolling-active', windowPosition);*/
    /*headersearch.classList.toggle('scrolling-active', windowPosition);
    headermap.classList.toggle('scrolling-active', windowPosition);
    headersavesearch.classList.toggle('scrolling-active', windowPosition);*/

    //stage 2
    let windowPosition2 = window.scrollY > defaultScrollPositionTwo;
    /*header.classList.toggle('scrolling-active2', windowPosition2);*/
    if (header2) {
        header2.classList.toggle('scrolling-active2', windowPosition2);
    }
    /*headersearch.classList.toggle('scrolling-active2', windowPosition2);
    headermap.classList.toggle('scrolling-active2', windowPosition2);
    headersavesearch.classList.toggle('scrolling-active2', windowPosition2);*/
});
window.addEventListener('DOMContentLoaded', function () {
    let header = document.querySelector('.only-show-mobile #open-search');
    let headersearch = document.querySelector('.stycky-search.stycky-wrapper-search #normalSearchWrapper');
    let headermap = document.querySelector('.map-target-for-fixed');
    let headersavesearch = document.querySelector('.mobile-sticky-bottom');
    let body = document.querySelector('body.public-body');
    /* let defaultScrollPositionOne = -1;
     let defaultScrollPositionTwo = -1;*/

    /*let windowPosition = window.scrollY > defaultScrollPositionOne;*/

    /*header.classList.toggle('scrolling-active', true);*/
    if (headersearch) {
        headersearch.classList.toggle('scrolling-active', true);
    }
    /*headermap.classList.toggle('scrolling-active', true);
    headersavesearch.classList.toggle('scrolling-active', true);*/

    //stage 2
    /*let windowPosition2 = window.scrollY > defaultScrollPositionTwo;*/
    /*header.classList.toggle('scrolling-active2', true);*/
    if (headersearch) {
        headersearch.classList.toggle('scrolling-active2', true);
    }
    /*headermap.classList.toggle('scrolling-active2', true);
    headersavesearch.classList.toggle('scrolling-active2', true);*/

});
